import { programmes as localProgrammes } from "./programmes";

/**
 * Single source of truth for the tuition fee calculator and the fee
 * directory, so both always show the same programmes, schools,
 * qualifications and amounts.
 */

const titleCase = (value = "") =>
  String(value)
    .replace(/_/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (letter) => letter.toUpperCase());

const displayQualification = (value = "") => {
  const normalised = titleCase(value);

  if (normalised === "Undergraduate" || normalised === "Bachelor") {
    return "Degree";
  }

  if (normalised === "Phd") {
    return "PhD";
  }

  if (normalised === "Tvet") {
    return "TVET";
  }

  return normalised;
};

const qualificationOrder = [
  "PhD",
  "Masters",
  "Postgraduate Diploma",
  "Degree",
  "Diploma",
  "TVET",
  "Professional",
  "Certificate",
];

const qualificationRank = (qualification) => {
  const rank = qualificationOrder.indexOf(qualification);
  return rank === -1 ? qualificationOrder.length : rank;
};

export const normaliseProgramme = (programme, index = 0) => {
  const fee = Number(programme.fee || 0);
  const feeType = programme.feeType || "Per Semester";
  const periods = Number(programme.duration || 0) || 0;
  const isRecurring = /per\s/i.test(feeType);

  return {
    // The source data reuses a few numeric ids, which produced duplicate React
    // keys and made "compare" pick the wrong programme. The slug is unique, so
    // it becomes the identity here (numeric id kept as a fallback).
    id: programme.slug || programme.id || index,
    title: programme.title || programme.name || "Untitled Programme",
    code: programme.code || "",
    school: programme.school || "",
    level: programme.level || "",
    qualification: displayQualification(
      programme.qualification || programme.category || programme.level || ""
    ),
    category: programme.category || "",
    fee,
    feeType,
    periods,
    durationType: programme.durationType || "",
    duration: programme.duration || "",
    // Total cost of the whole programme
    totalFee: isRecurring && periods > 0 ? fee * periods : fee,
    isRecurring,
  };
};

export const feeProgrammes = localProgrammes
  .map(normaliseProgramme)
  .sort((a, b) => {
    const levelDifference = qualificationRank(a.qualification) - qualificationRank(b.qualification);
    return levelDifference || a.title.localeCompare(b.title);
  });

export const uniqueSorted = (values) =>
  ["All", ...Array.from(new Set(values.filter(Boolean))).sort((a, b) => a.localeCompare(b))];

export const filterProgrammes = (rows, { search = "", school = "All", qualification = "All" }) => {
  const term = search.trim().toLowerCase();

  return rows.filter((row) => {
    const matchesSearch =
      !term ||
      row.title.toLowerCase().includes(term) ||
      row.school.toLowerCase().includes(term) ||
      row.code.toLowerCase().includes(term);

    const matchesSchool = school === "All" || row.school === school;
    const matchesQualification =
      qualification === "All" || row.qualification === qualification;

    return matchesSearch && matchesSchool && matchesQualification;
  });
};
